import { colors } from '@airship-platform/jam-design-tokens';

export type AirshipThemeOption =
  | 'AIRSHIP_BLUE'
  | 'AIRSHIP_RED'
  | 'AIRSHIP_GOLD';
export type AirshipThemePalette = 'airshipBlue' | 'airshipRed' | 'airshipGold';

export interface AirshipThemeColors {
  primary: string;
  secondary: string;
  accent: string;
}

const themeColorMap: Record<AirshipThemeOption, AirshipThemeColors> = {
  AIRSHIP_BLUE: {
    primary: colors.blue[800],
    secondary: colors.blue[300],
    accent: colors.blue[200],
  },
  AIRSHIP_RED: {
    primary: colors.red[800],
    secondary: colors.red[300],
    accent: colors.red[200],
  },
  AIRSHIP_GOLD: {
    primary: colors.gold[800],
    secondary: colors.gold[300],
    accent: colors.gold[200],
  },
};

export function getAirshipThemeColors(
  themeOption: AirshipThemeOption
): AirshipThemeColors {
  return themeColorMap[themeOption];
}

export function getAirshipThemePalette(
  themeOption: AirshipThemeOption
): AirshipThemePalette {
  switch (themeOption) {
    case 'AIRSHIP_BLUE':
      return 'airshipBlue';
    case 'AIRSHIP_RED':
      return 'airshipRed';
    case 'AIRSHIP_GOLD':
      return 'airshipGold';
  }
}

export function getAirshipThemeOption(
  palette: AirshipThemePalette
): AirshipThemeOption {
  switch (palette) {
    case 'airshipBlue':
      return 'AIRSHIP_BLUE';
    case 'airshipRed':
      return 'AIRSHIP_RED';
    case 'airshipGold':
      return 'AIRSHIP_GOLD';
  }
}
